/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateConsumerCustomerWithContractResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateConsumerCustomerWithContractCommand, serializeCreateConsumerCustomerWithContractResult, type CreateConsumerCustomerWithContractCommand, type CreateConsumerCustomerWithContractResult, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/consumer/with-contract
 */
export interface WithContractRequestBuilder extends BaseRequestBuilder<WithContractRequestBuilder> {
    /**
     * CreateConsumerCustomerWithContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateConsumerCustomerWithContractResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateConsumerCustomerWithContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateConsumerCustomerWithContractResult | undefined>;
    /**
     * CreateConsumerCustomerWithContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateConsumerCustomerWithContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithContractRequestBuilderUriTemplate = "{+baseurl}/customers/consumer/with-contract";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithContractRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: WithContractRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateConsumerCustomerWithContractResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateConsumerCustomerWithContractCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
